import moment from 'moment'
import Constants from '../shared/Constants'
import 'moment-timezone';
import timezones from '../shared/timezones'

export default {

    fetchTimeZoneByNumber(timeZoneNumber){
        var timezoneCountry;
        if(timeZoneNumber !== "" || timeZoneNumber !== null){
            for(let i=0; i<timezones.timezone.length; i++){
            
                if(timezones.timezone[i].offset === timeZoneNumber){
                    timezoneCountry = timezones.timezone[i].utc[0];
                }
            }
            return timezoneCountry;
        }       
    },
    fetchTimeZoneByCountry(timezoneCountry){
        var timeZoneNumber;
        if(timezoneCountry !== "" || timezoneCountry !== null){
            for(let i=0; i<timezones.timezone.length; i++){
                for(let j=0; j<timezones.timezone.length; j++){
                    if(timezones.timezone[i].utc[j] === timezoneCountry){
                        timeZoneNumber = timezones.timezone[i].offset;
                    }
                }
            }
            return timeZoneNumber;
        }       
    },

    getConvertedDateTime(dateTimeString){
        let momentDate;
        if(!dateTimeString){
            return '-';
        }
        momentDate = moment(dateTimeString);
        if(!momentDate){
            return '-';
        }
        return (momentDate.format(Constants.dateTimeFormat));
    },

    getConvertedTime(dateTimeString){
        let momentDate;
        if(!dateTimeString){
            return '-';
        }
        momentDate = moment(dateTimeString);
        if(!momentDate){
            return '-';
        }
        return momentDate.format(Constants.timeFormat);
    },

    getConvertedDate(dateTimeString){
        let momentDate;
        if(!dateTimeString){
            return '-';
        }
        momentDate = moment(dateTimeString);
        if(!momentDate){
            return '-';
        }
        return momentDate.format(Constants.dateFormat);
    }
}
